<template>
  <div class="bbr-canonical-exercises">
    <main-app-bar>
      <template v-slot:title> Canonical Exercises </template>

      <template v-slot:top-actions>
        <v-btn
          class="ml-auto mr-3"
          color="primary"
          outlined
          :to="{ name: 'similar-canonical-exercises' }"
        >
          <v-icon class="mr-2">{{ icons.compare }}</v-icon>
          Find Similar
        </v-btn>
        <v-btn
          class="bg-primary-gradient primary"
          depressed
          @click="openCreate"
        >
          <v-icon class="mr-2">{{ icons.add }}</v-icon>
          Add New
        </v-btn>
      </template>
    </main-app-bar>

    <div class="mt-5 px-12 mb-10">
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Search Canonical Exercise"
            style="width: 400px"
            @input="onSearch"
            hide-details
            clearable
            rounded
            solo
            flat
          />
        </v-col>

        <v-col cols="12">
          <canonical-exercise-list
            :is-loading="isLoading"
            @load="loadMore"
            @edit="openEdit"
            @delete="confirmDelete"
          />
        </v-col>
      </v-row>
    </div>

    <canonical-exercise-form-dialog
      v-model="showFormDialog"
      :canonical-exercise="editing"
      @saved="onSaved"
    />

    <v-dialog v-model="showDeleteDialog" width="600" persistent>
      <v-card class="mx-auto" outlined>
        <v-card-title class="headline">Delete Canonical Exercise</v-card-title>

        <v-divider />

        <v-card-text class="py-5">
          Delete "<strong>{{ deleting && deleting.name }}</strong
          >"? Linked exercises will be unlinked, but their weight history is
          preserved.
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 pb-6 pt-5">
          <v-spacer />

          <v-btn
            class="px-12 error--text"
            text
            :disabled="deleteBusy"
            @click="showDeleteDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            class="primary px-12"
            text
            :loading="deleteBusy"
            :disabled="deleteBusy"
            @click="remove"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainAppBar from '@/layouts/shared/MainAppBar'
import CanonicalExerciseList from './components/CanonicalExerciseList'
import CanonicalExerciseFormDialog from './components/CanonicalExerciseFormDialog'

import { mapActions, mapMutations } from 'vuex'
import { debounce } from 'lodash'
import { mdiPlus, mdiCompare } from '@mdi/js'

export default {
  name: 'CanonicalExercises',

  components: {
    MainAppBar,
    CanonicalExerciseList,
    CanonicalExerciseFormDialog,
  },

  data() {
    return {
      search: null,
      isLoading: false,
      showFormDialog: false,
      editing: null,
      showDeleteDialog: false,
      deleting: null,
      deleteBusy: false,
      icons: {
        add: mdiPlus,
        compare: mdiCompare,
      },
    }
  },

  mounted() {
    this.clearList()
    this.fetch()
  },

  methods: {
    ...mapActions({
      getCanonicalExercises: 'canonicalExercises/getCanonicalExercises',
      deleteCanonicalExercise: 'canonicalExercises/deleteCanonicalExercise',
    }),

    ...mapMutations({
      clearList: 'canonicalExercises/clearList',
    }),

    async fetch(page = 1) {
      this.isLoading = true
      try {
        await this.getCanonicalExercises({
          search: this.search,
          page,
          limit: 50,
        })
      } finally {
        this.isLoading = false
      }
    },

    loadMore(page) {
      this.fetch(page)
    },

    onSearch(term) {
      this.search = term
      this.searchDebounced()
    },

    searchDebounced: debounce(function() {
      this.clearList()
      this.fetch()
    }, 600),

    openCreate() {
      this.editing = null
      this.showFormDialog = true
    },

    openEdit(canonicalExercise) {
      this.editing = canonicalExercise
      this.showFormDialog = true
    },

    onSaved() {
      this.clearList()
      this.fetch()
    },

    confirmDelete(canonicalExercise) {
      this.deleting = canonicalExercise
      this.showDeleteDialog = true
    },

    async remove() {
      this.deleteBusy = true
      try {
        await this.deleteCanonicalExercise(this.deleting.id)
        this.showDeleteDialog = false
        this.deleting = null
        this.clearList()
        this.fetch()
      } finally {
        this.deleteBusy = false
      }
    },
  },
}
</script>
